import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63da5f0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da5f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63da5f0a')) {
      api.createRecord('63da5f0a', component.options)
    } else {
      api.reload('63da5f0a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63da5f0a&scoped=true", function () {
      api.rerender('63da5f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/integral/integralLog/index.vue"
export default component.exports